import { render } from "./TextHighlighter.vue?vue&type=template&id=012abf12"
import script from "./TextHighlighter.vue?vue&type=script&lang=js"
export * from "./TextHighlighter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__